import React from 'react';
import { Award } from 'lucide-react';
import HRISListPage from '../HRISListPage';
import { getTenure, createTenureRecord, updateTenureRecord, deleteTenureRecord, getEmployeeList } from '../hrisApi';

const STATUS_OPTIONS = ['Active', 'Completed', 'Pending', 'Cancelled'];
const RECORD_TYPES = ['Onboarding', 'Contract', 'Probation', 'Milestone', 'Separation', 'Transfer'];

const columns = [
  { key: 'employeeName', label: 'Employee' },
  { key: 'recordType', label: 'Type' },
  { key: 'startDate', label: 'Start Date' },
  { key: 'endDate', label: 'End Date' },
  { key: 'ownerName', label: 'Owner' },
  { key: 'status', label: 'Status', badge: true },
];

const formFields = [
  { key: 'employeeName', label: 'Employee', type: 'select', required: true, optionsLoader: getEmployeeList },
  { key: 'recordType', label: 'Record Type', type: 'select', required: true, options: RECORD_TYPES },
  { key: 'startDate', label: 'Start Date', type: 'date', required: true },
  { key: 'endDate', label: 'End Date', type: 'date' },
  { key: 'ownerName', label: 'Process Owner', type: 'text', placeholder: 'HR owner or manager' },
  { key: 'status', label: 'Status', type: 'select', options: STATUS_OPTIONS, defaultValue: 'Active' },
  { key: 'notes', label: 'Notes', type: 'textarea', placeholder: 'Lifecycle notes...' },
];

const Tenure = () => (
  <HRISListPage
    title="Tenure"
    description="Manage onboarding, contracts, milestones, probation, and separation records"
    icon={<Award />}
    columns={columns}
    fetchData={getTenure}
    createData={createTenureRecord}
    updateData={updateTenureRecord}
    deleteData={deleteTenureRecord}
    formFields={formFields}
    entityName="Tenure Record"
    searchPlaceholder="Search employee, lifecycle type, owner..."
  />
);

export default Tenure;
